import I18n from 'js/lib/i18n.js.erb'
;(function ($) {
  $(document).ready(function () {
    var $wrapper = $('.column-form__fieldset.two-factor-auth')

    if ($wrapper.length > 0) {
      var $enabledCheckbox = $wrapper.find('.switch input[type="checkbox"]')
      var $mobileWrapper = $wrapper.find('.input.stringish')
      var $mobileInput = $mobileWrapper.find('input')

      $enabledCheckbox.on('change', function () {
        if ($(this).prop('checked')) {
          $mobileWrapper.stop(true).slideDown()
        } else {
          $mobileWrapper.stop(true).slideUp()
        }
      })

      $mobileInput.intlTelInput({
        initialCountry: 'AU',
        formatOnInit: true,
        hiddenInput: $mobileInput.prop('name'),
        autoPlaceholder: 'aggressive',
        customPlaceholder: function () {
          return I18n.t('intl_tel_input.placeholder')
        },
      })
    }
  })
})(jQuery)
